import notLoggedIn from 'util/not-logged-in'
import app from './app'
import debug from 'debug'
import * as Sentry from '@sentry/react'

const reportingVersion = `${VERSION}-${BUILD_NUMBER}`
const logVersion = debug('vo:versioning')

logVersion(`package version: ${VERSION}`)
logVersion(`jenkins build num: ${BUILD_NUMBER}`)
logVersion(`reported version: ${reportingVersion}`)

window.VO_VERSION = {
  version: VERSION,
  buildNumber: BUILD_NUMBER,
  reportingVersion,
}

Sentry.init({
  dsn:
    'https://7061c88343ab493390fef978c0d53a5a@o378897.ingest.sentry.io/5673598',
})

function startApp() {
  // Only initialize Pendo after confirming the user is unauthenticated.
  if (typeof window.initializePendoAnonymous === 'function') {
    try {
      const host = window.location.hostname
      const parent = host
        .split('.')
        .slice(-2)
        .join('.')
      const cookieDomain = parent.includes('.') ? '.' + parent : undefined
      window.initializePendoAnonymous({ cookieDomain })
    } catch (e) {
      console.error('[Pendo] Initialization failed:', e)
    }
  }

  // Start the app after confirming the user is unauthenticated.
  app()
}

notLoggedIn(startApp)
